import { render, staticRenderFns } from "./matchWorks.vue?vue&type=template&id=6c51dfe1&"
import script from "./matchWorks.vue?vue&type=script&lang=js&"
export * from "./matchWorks.vue?vue&type=script&lang=js&"
import style0 from "./matchWorks.vue?vue&type=style&index=0&id=6c51dfe1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c51dfe1')) {
      api.createRecord('6c51dfe1', component.options)
    } else {
      api.reload('6c51dfe1', component.options)
    }
    module.hot.accept("./matchWorks.vue?vue&type=template&id=6c51dfe1&", function () {
      api.rerender('6c51dfe1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/match/matchWorks.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/match/matchWorks.vue
// module id = RsVt
// module chunks = 0